// extracted by mini-css-extract-plugin
module.exports = {"button":"_9e1425b4d3--button--IqIpq","loading":"_9e1425b4d3--loading--xAfj5","spinner":"_9e1425b4d3--spinner--JT5Jo"};